import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const GoogleCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { googleLogin } = useAuth();
    const [error, setError] = useState('Processing login...');

    useEffect(() => {
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (!code) {
            setError('No authorization code found');
            return;
        }

        const handleCallback = async () => {
            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/google/callback`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code, state }),
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.error || 'Login failed');
                }

                // Update auth context
                await googleLogin(data);

                // Redirect based on role
                const role = data.user.role;
                if (role === 'doctor') navigate('/doctor/dashboard');
                else if (role === 'admin') navigate('/admin/dashboard');
                else if (role === 'clinic_owner') navigate('/clinic/dashboard');
                else navigate('/patient/dashboard');

            } catch (err) {
                console.error('Google Callback Error:', err);
                setError(err.message || 'Authentication failed');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleCallback();
    }, [searchParams, googleLogin, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-light-bg dark:bg-obsidian">
            <div className="text-center p-8 glass rounded-2xl">
                <h2 className="text-xl font-display mb-4 dark:text-white">Google Login</h2>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
                <p className="text-light-text-secondary dark:text-silver/60">{error}</p>
            </div>
        </div>
    );
};

export default GoogleCallback;
